<template>
  <div>

    <template v-if="fullloading">
      <div class="text-center">
        <b-spinner class="m-5" label="Busy"></b-spinner>
      </div>
    </template>
    <template v-else>
      <div>
        <h1>{{ $lang("參賽兒童及家庭成員") }}</h1>
        <p class="text-danger">{{ $lang("其中必須有兒童參與") }}</p>
      </div>
      <div>
        <b-form @submit="onSubmit">
          <template v-for="(item, index) in childMembers">
            <item-form :usetype="5" :showZhName="showZhName" :key="item.key" class="dashed" :rules="rules"
              :index="index" :disabled="item.readOnlyStatus == 2" :value.sync="item" ref="form-item">
              <template v-if="childMembers.length > 1" v-slot:remove>
                <b-form-group horizontal>
                  <label slot="label"></label>
                  <b-btn variant="info" size="sm" class="del" @click="handleRemoveC(item)">
                    <i class="fa fa-trash-o" style="margin-right: 5px"></i>
                    {{ $lang("刪除") }}
                  </b-btn>
                </b-form-group>
              </template>
            </item-form>
          </template>

          <div class="form-footer dashed">
            <div v-if="readOnlyStatus == 1">{{ $lang("10021") }}</div>
            <div v-else-if="readOnlyStatus == 2">{{ $lang("1022") }}</div>
            <div>
              <template>
                <b-btn v-if="readOnlyStatus != 2" variant="success btn-round" @click="handleAddC">+{{ $lang("添加兒童")
                }}</b-btn>
              </template>
            </div>
          </div>
          <template v-for="(item, index) in members">
            <item-form :index="index" :usetype="4" :showZhName="showZhName" :parentMessage="parentMessage"
              :key="item.key" class="dashed" :rules="rules" :disabled="item.readOnlyStatus == 2" :value.sync="item"
              ref="form-item">
              <template v-if="members.length > 2" v-slot:remove>
                <b-form-group horizontal>
                  <label slot="label"></label>
                  <b-btn variant="info" size="sm" class="del" @click="handleRemove(item)">
                    <i class="fa fa-trash-o" style="margin-right: 5px"></i>
                    {{ $lang("刪除") }}
                  </b-btn>
                </b-form-group>
              </template>
            </item-form>
          </template>

          <div class="form-footer dashed">
            <div v-if="readOnlyStatus == 1">{{ $lang("10021") }}</div>
            <div v-else-if="readOnlyStatus == 2">{{ $lang("1022") }}</div>
            <div>
              <template>
                <b-btn v-if="readOnlyStatus != 2" variant="success btn-round" @click="handleAdd">+{{ $lang("添加參賽者")
                }}</b-btn>
              </template>
              <b-btn variant="success btn-round" @click="$router.push({ name: 'family-day-2019' })">{{
                $lang("TITLE_RETURN_INDEX")
              }}</b-btn>
            </div>
          </div>
        </b-form>
      </div>
    </template>
  </div>
</template>

<script>
import { $apis } from "@/helper";
import ItemForm from "@/components/ItemForm";
import LaddaBtn from "@/components/ladda/Ladda";
import utils from "@/helper/utils";

export default {
  components: {
    ItemForm,
    LaddaBtn,
  },
  data() {
    return {
      parentMessage: "",
      index: 3,
      showZhName: false,

      rules: {
        birth: {
          required: true,
          familyComing_age: [2015],
        },
        childBirth: {
          childBirth: [2016, 2024],
          required: true,
        },
        ChineseName: {
          required: true,
          ChineseName: true,
        },
        PtName: {
          required: true,
          PtName: true,
        },
        // lastName: {
        //   ChineseName: true,
        //   required: true,
        // },
        // firstName: {
        //   ChineseName: true,
        //   required: true,
        // },
        lastNameOther: {
          required: true,
        },
        firstNameOther: {
          required: true,
        },
        sex: {
          required: true,
        },
        idType: {
          required: true,
        },
        idNumber: {
          required: true,
          idNumber: true,
        },
      },
      fullloading: false,
      loading: false,
      childMembers: [
        {
          lastName: "",
          firstName: "",
          lastNameOther: "",
          firstNameOther: "",
          gender: "",
          bornAt: "",
          idType: 1,
          idNumber: "",
          showZhName: false,
          uuid: "",
        },
      ],
      members: [
        {
          lastName: "",
          firstName: "",
          lastNameOther: "",
          firstNameOther: "",
          gender: "",
          bornAt: "",
          showZhName: false,
          uuid: "",
        },
        {
          lastName: "",
          firstName: "",
          lastNameOther: "",
          firstNameOther: "",
          gender: "",
          bornAt: "",
          showZhName: false,
          uuid: "",
        },
      ],
      phone: "",
      readOnlyStatus: 0,
      allowcheck: false,
    };
  },
  methods: {
    computedList(members) {
      let list = [];
      members.forEach((item) => {
        if (item.idNumber) {
          list.push({
            showZhName: !item.showZhName,
            lastName: item.lastName,
            firstName: item.firstName,
            lastNameOther: item.lastNameOther,
            firstNameOther: item.firstNameOther,
            gender: item.gender,
            bornAt: item.bornAt,
            idType: item.idType,
            idNumber: item.idNumber,
            readOnlyStatus: item.readOnlyStatus,
            uuid: item.uuid,
          });
        } else {
          list.push({
            showZhName: !item.showZhName,
            lastName: item.lastName,
            firstName: item.firstName,
            lastNameOther: item.lastNameOther,
            firstNameOther: item.firstNameOther,
            gender: item.gender,
            bornAt: item.bornAt,
            readOnlyStatus: item.readOnlyStatus,
            uuid: item.uuid,
          });
        }
      });
      return list;
    },
    handleRemove(item) {
      if (this.members.length <= 2) {
        this.notification.warning(this.$lang("最少二人"));
        return;
      }
      var index = this.members.indexOf(item);
      if (index !== -1) {
        this.members.splice(index, 1);
      }
    },
    handleRemoveC(item) {
      if (this.childMembers.length <= 1) {
        this.notification.warning(this.$lang("最少一個兒童"));
        return;
      }
      var index = this.childMembers.indexOf(item);
      if (index !== -1) {
        this.childMembers.splice(index, 1);
      }
    },
    handleAddC() {
      this.index++;
      this.childMembers.push({
        showZhName: false,
        index: this.index,
        lastName: "",
        firstName: "",
        lastNameOther: "",
        firstNameOther: "",
        gender: "",
        bornAt: "",
        idType: 1,
        idNumber: "",
        uuid: "",
      });
    },
    handleAdd() {
      this.index++;
      this.members.push({
        showZhName: false,
        index: this.index,
        lastName: "",
        firstName: "",
        lastNameOther: "",
        firstNameOther: "",
        gender: "",
        bornAt: "",
        uuid: "",
      });
    },
    fillterChild(arr) {
      let date_start = new Date("2016-01-01").getTime();
      let date_end = new Date("2024-12-31").getTime();
      let result = arr.some((item) => {
        let time = new Date(item.bornAt).getTime();
        return time >= date_start && time <= date_end;
      });
      return result;
    },
    editFamilyList(params) {
      return new Promise((resolve, reject) => {
        this.$apis.family
          .editFamilyList(params, this.showZhName)
          .then((resp) => {
            if (resp.code === 0) {
              resolve(resp);
            } else {
              reject(resp);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    uploadMembers() {
      let lists = JSON.parse(
        JSON.stringify([...this.childMembers, ...this.members])
      );
      let list = lists.map((item) => {
        delete item["index"];
        delete item["readOnlyStatus"];
        item.showZhName = !item.showZhName;
        item.bornAt = this.$changeTime(item.bornAt) || "";
        return item;
      });
      console.log(list);
      return list;
    },
    filterIdNumber(arr) {
      let list = arr.map((item) => item.idNumber);
      let flat = utils.isRepeat(list);
      if (flat) {
        this.notification.warning(this.$lang("身份信息不能重複"));
      }
      return flat;
    },
    onSubmit(evt) {
      this.parentMessage = '';
      return new Promise((resolve, reject) => {
        if (this.readOnlyStatus == 2) {
          resolve(true);
        } else {
          // console.log("test", this.$refs["form-item"]);
          let params = this.uploadMembers();
          let showZhName = this.showZhName;
          let promise_list = this.$refs["form-item"].map((item) =>
            item.onSubmit()
          );
          Promise.all(promise_list).then((list) => {
            var result = list.every((item) => item);
            // this.errorScoll();
            console.log(result);
            if (result) {
              //!this.filterIdNumber(params)
              if (true) {
                if (this.fillterChild(params)) {
                  this.loading = true;
                  this.editFamilyList(params)
                    .then((resp) => {
                      if (resp.code === 0) {
                        this.notification.success(this.$lang("提交成功"));
                        resolve(true);
                      } else {
                        resolve(false);
                      }
                    })
                    .catch((err) => {
                      console.log(err, "err");
                      if (
                        err.data.message &&
                        typeof err.data.message === "string"
                      ) {

                        this.notification.error(this.$lang(err.data.message));
                        this.parentMessage = this.$lang(err.data.message)
                        console.log(this.parentMessage)
                      } else if (
                        err.data &&
                        Object.keys(err.data) instanceof Array
                      ) {
                        var that = this;
                        Object.keys(err.data).forEach(function (key) {
                          that.$refs["form-item"][key].validateErrors(
                            err.data[key].path,
                            that.$lang(err.data[key].message)
                          );
                          that.notification.error(
                            that.$lang(err.data[key].message)
                          );
                        });
                      } else {
                        this.notification.error(this.$lang(err.message));
                      }
                      //        if (err.data.message instanceof Array) {
                      //    .forEach((item, index) => {
                      //         this.$refs["form-item"][index].validateErrors(
                      //             item.path,
                      //             this.$lang(item.message)
                      //         );
                      //         this.notification.error(this.$lang(item.message));
                      //     });
                      // } else {
                      //     var teamMembers = err.data;
                      //     var that = this;
                      //     Object.keys(teamMembers).forEach(function (key) {
                      //         that.$refs["form-item"][key].validateErrors(
                      //             teamMembers[key].path,
                      //             that.$lang(teamMembers[key].message)
                      //         );
                      //         that.notification.error(
                      //             that.$lang(teamMembers[key].message)
                      //         );
                      //     });
                      // }

                      resolve(false);
                    })
                    .finally(() => {
                      this.loading = false;
                      this.errorScoll();
                    });
                } else {
                  this.notification.warning(this.$lang("必须有一名儿童参加"));
                  resolve(false);
                }
              } else {
                resolve(false);
              }
            } else {
              resolve(false);
            }
          });
        }
      });
    },
    errorScoll() {
      let errEle = document.querySelector(".is-invalid");
      errEle ? this.animateScroll(errEle, 50) : "";
    },
    animateScroll(element, speed) {
      //获取元素相对窗口的top值，此处应加上窗口本身的偏移
      let top = window.pageYOffset + element.getBoundingClientRect().top;
      // 获取当前距离窗口的top值
      let osTop = document.documentElement.scrollTop || document.body.srcollTop;
      let requestId;
      let currentNumber = 0;
      //采用requestAnimationFrame，平滑动画
      function step() {
        if (osTop >= top) {
          currentNumber = osTop -= speed;
          window.scrollTo(0, osTop);
          requestId = window.requestAnimationFrame(step);
        } else {
          window.cancelAnimationFrame(requestId);
        }
      }
      window.requestAnimationFrame(step);
    },
    // 获取家庭成员列表
    getFamilyList() {
      this.fullloading = true;
      return new Promise((resolve, reject) => {
        $apis.family
          .familyList()
          .then((resp) => {
            //member
            let m = [];
            //childmember
            let cm = [];
            if (resp.data.members.length >= 3) {
              resp.data.members.forEach((item) => {
                if (item.is10AgeLater) {
                  m.push(item);
                } else {
                  cm.push(item);
                }
              });
              this.members = this.computedList(m);
              this.childMembers = this.computedList(cm);
            }

            this.readOnlyStatus = resp.data.readOnlyStatus;
            // this.showZhName = !resp.data.showZhName;
            let countRecords = resp.data.countRecords;
            let length = resp.data.members.filter((item) => !item.isAdult)
              .length;
            // if (countRecords > 0 && length == countRecords) {
            //     this.$router.replace({
            //         name: "family-day-2019"
            //     });
            // }
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          })
          .finally(() => {
            this.fullloading = false;
          });
      });
    },
    //获取使用者资料
    getUserInfo() {
      this.loading = false;
      $apis.user
        .getUserInfo()
        .then((resp) => {
          if (!resp.data.lastNameZh || !resp.data.firstNameZh)
            this.showZhName = true;

          this.members[0]["showZhName"] = resp.data.noChineseName;
          this.members[0]["lastName"] = resp.data.lastNameZh;
          this.members[0]["firstName"] = resp.data.firstNameZh;
          this.members[0]["lastNameOther"] = resp.data.lastNamePt;
          this.members[0]["firstNameOther"] = resp.data.firstNamePt;
          this.members[0]["gender"] = resp.data.gender;
          this.members[0]["bornAt"] = resp.data.bornAt;
          this.members[0]["uuid"] = "";
          // this.members[0]["idType"] = resp.data.idType;
          //加入数据方便test
          // this.members[1]["lastName"] = resp.data.lastNameZh;
          // this.members[1]["firstName"] = resp.data.firstNameZh;
          // this.members[1]["lastNameOther"] = resp.data.lastNamePt;
          // this.members[1]["firstNameOther"] = resp.data.firstNamePt;
          // this.members[1]["gender"] = resp.data.gender;
          // this.members[1]["bornAt"] = resp.data.bornAt;
          // this.members[1]["idType"] = resp.data.idType;
          // this.members[1]["idNumber"] = resp.data.idNumber;
          // this.members[2]["lastName"] = resp.data.lastNameZh;
          // this.members[2]["firstName"] = resp.data.firstNameZh;
          // this.members[2]["lastNameOther"] = resp.data.lastNamePt;
          // this.members[2]["firstNameOther"] = resp.data.firstNamePt;
          // this.members[2]["gender"] = resp.data.gender;
          // this.members[2]["bornAt"] = resp.data.bornAt;
          // this.members[2]["idType"] = resp.data.idType;
          // this.members[2]["idNumber"] = resp.data.idNumber;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = true;
        });
    },
  },
  async created() {
    // 获取家庭成员列表
    let result = await this.getFamilyList();
    if (result.data.members.length == 0) this.getUserInfo();
  },
  watch: {
    showZhName(n) {
      if (n) {
        this.members.map((item) => {
          item.lastName = "";
          item.firstName = "";
        });
      } else {
        this.$refs["form-item"].map((item) => item.clean());
      }
    },
  },
};
</script>
